import { StyledProductsTopFilter } from '../../../ui/Form/filters/style';
import { useIntl } from 'react-intl';
import { PageSizeSelector } from '../../../ui/Select/Selectors/PageSizeSelector';
import { SortSelector } from '../../../ui/Select/Selectors/SortSelector';
import { useEffect } from 'react';
import { ListingFilters } from './types';

export interface ListingsTopFilterProps {
  total?: number;
  per_page?: number;
  setFilter?: (fieldsValue: Partial<ListingFilters>) => void;
  page_size_options?: number[];
  setPageSize: (value: number) => void;
  filters?: ListingFilters;
}

export const ListingsTopFilter = ({
  total,
  setFilter,
  page_size_options,
  setPageSize,
  filters,
  per_page,
}: ListingsTopFilterProps) => {
  const intl = useIntl();
  const [form] = StyledProductsTopFilter.useForm();

  useEffect(() => {
    if (!!filters) {
      form.setFieldsValue(filters);
    }
  }, [filters, form]);

  const hasLocationSet = !!(
    (filters?.lks_lat && filters?.lks_long) ||
    filters?.location
  );

  const sortOptions = [
    { value: 'listing_date', labelId: 'listing.sort.listing_date' },
    { value: 'offer_creation_date', labelId: 'listing.sort.offer_creation_date' },
    { value: 'products_amount', labelId: 'listing.sort.products_amount' },
    {
      value: 'distance',
      labelId: 'listing.sort.distance',
      disabled: !hasLocationSet,
      disabledTooltipId: 'listing.sort.distance.disabled.tooltip'
    },
  ];

  const handleSortChange = (orderBy?: string, direction?: 'asc' | 'desc') => {
    if (setFilter) {
      const currentValues = form.getFieldsValue();
      setFilter({
        ...currentValues,
        order_by: orderBy,
        order_direction: direction,
      });
    }
  };

  return (
    <StyledProductsTopFilter
      form={form}
      onFieldsChange={() => setFilter && setFilter(form.getFieldsValue())}
    >
      <div className={'catalogue-number'}>
        {`${intl.formatMessage({
          id: 'listing.top.filter.catalogue',
        })}: ${total} ${intl.formatMessage({ id: 'top_filter.listings' })}`}
      </div>
      <div className={'filter-order'}>
        <SortSelector
          withDivider={true}
          options={sortOptions}
          onChange={handleSortChange}
          defaultOrderBy={filters?.order_by ?? 'listing_date'}
          defaultDirection={filters?.order_direction ?? 'desc'}
        />
      </div>
      <div className={'filter-page'}>
        <PageSizeSelector
          page_size_options={page_size_options ?? [20, 40]}
          setPageSize={setPageSize}
          value={per_page}
        />
      </div>
    </StyledProductsTopFilter>
  );
};